import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-073084bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["transform"]
const _hoisted_4 = ["d", "fill", "stroke", "stroke-width", "stroke-dasharray"]
const _hoisted_5 = ["innerHTML"]

import { computed, PropType } from 'vue'
import { PPTShapeElement, ShapeText } from '@/types/slides'
import useElementOutline from '@/views/components/element/hooks/useElementOutline'
import useElementShadow from '@/views/components/element/hooks/useElementShadow'
import useElementFlip from '@/views/components/element/hooks/useElementFlip'

import GradientDefs from './GradientDefs.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseShapeElement',
  props: {
  elementInfo: {
    type: Object as PropType<PPTShapeElement>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const outline = computed(() => props.elementInfo.outline)
const { outlineWidth, outlineStyle, outlineColor } = useElementOutline(outline)

const shadow = computed(() => props.elementInfo.shadow)
const { shadowStyle } = useElementShadow(shadow)

const flipH = computed(() => props.elementInfo.flipH)
const flipV = computed(() => props.elementInfo.flipV)
const { flipStyle } = useElementFlip(flipH, flipV)

const text = computed<ShapeText>(() => {
  const defaultText: ShapeText = {
    content: '',
    defaultFontName: '微软雅黑',
    defaultColor: '#000',
    align: 'middle',
  }
  if (!props.elementInfo.text) return defaultText

  return props.elementInfo.text
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-shape",
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
      height: __props.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", {
        class: "element-content",
        style: _normalizeStyle({
          opacity: __props.elementInfo.opacity,
          filter: _unref(shadowStyle) ? `drop-shadow(${_unref(shadowStyle)})` : '',
          transform: _unref(flipStyle),
          color: _unref(text).defaultColor,
          fontFamily: _unref(text).defaultFontName,
        })
      }, [
        (_openBlock(), _createElementBlock("svg", {
          overflow: "visible",
          width: __props.elementInfo.width,
          height: __props.elementInfo.height
        }, [
          (__props.elementInfo.gradient)
            ? (_openBlock(), _createElementBlock("defs", _hoisted_2, [
                _createVNode(GradientDefs, {
                  id: `base-gradient-${__props.elementInfo.id}`,
                  type: __props.elementInfo.gradient.type,
                  color1: __props.elementInfo.gradient.color[0],
                  color2: __props.elementInfo.gradient.color[1],
                  rotate: __props.elementInfo.gradient.rotate
                }, null, 8, ["id", "type", "color1", "color2", "rotate"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("g", {
            transform: `scale(${__props.elementInfo.width / __props.elementInfo.viewBox[0]}, ${__props.elementInfo.height / __props.elementInfo.viewBox[1]}) translate(0,0) matrix(1,0,0,1,0,0)`
          }, [
            _createElementVNode("path", {
              "vector-effect": "non-scaling-stroke",
              "stroke-linecap": "butt",
              "stroke-miterlimit": "8",
              d: __props.elementInfo.path,
              fill: __props.elementInfo.gradient ? `url(#base-gradient-${__props.elementInfo.id})` : __props.elementInfo.fill,
              stroke: _unref(outlineColor),
              "stroke-width": _unref(outlineWidth),
              "stroke-dasharray": _unref(outlineStyle) === 'dashed' ? '10 5' : '0 0'
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_3)
        ], 8, _hoisted_1)),
        _createElementVNode("div", {
          class: _normalizeClass(["shape-text", _unref(text).align])
        }, [
          _createElementVNode("div", {
            class: "ProseMirror-static",
            innerHTML: _unref(text).content
          }, null, 8, _hoisted_5)
        ], 2)
      ], 4)
    ], 4)
  ], 4))
}
}

})